import { useState } from 'react'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import {
  Mtds,
  EmptyState,
  PlusIcon,
  ScreenHeader,
  TopBar,
  AppLayout,
  useGetContractsQuery
} from 'prove-common'
import ContractsTable from '../tables/ContractsTable'
import CreateContractModal from '../components/create-contract-modal/CreateContractModal'
import { AppLogo } from '../components/app-logo/AppLogo'

export default function ContractsScreen() {
  const {
    data: contracts,
    isPending,
    isError,
    isSuccess
  } = useGetContractsQuery()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <AppLayout
      useMobileBar={false}
      sidebar={<SideBarLayout />}
      isLoading={isPending}
      isError={isError}
      topBar={
        <TopBar
          logo={<AppLogo />}
          title='Kontrakter'
          showNotificationBell={true}
        />
      }
      isFullWidth
    >
      <ScreenHeader
        title='Kontrakter'
        description={
          <p>
            Her finner du en oversikt over kontrakter som brukes i
            planleggingen. Opprett og administrer kontrakter slik at planer og
            oppgaver kan kobles til riktig avtalegrunnlag.
          </p>
        }
        actions={
          <Mtds.Button
            data-variant='primary'
            onClick={() => setIsModalOpen(true)}
          >
            <PlusIcon />
            Opprett kontrakt
          </Mtds.Button>
        }
      />
      {isSuccess &&
        (contracts.length ? (
          <ContractsTable contracts={contracts} />
        ) : (
          <EmptyState
            title='Ingen kontrakter'
            description='Opprett en kontrakt for å komme i gang.'
          />
        ))}
      <CreateContractModal isOpen={isModalOpen} setOpen={setIsModalOpen} />
    </AppLayout>
  )
}
